import React, {FC, useEffect} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useFormik} from 'formik'
import {IApplicationModel, IApplicationUpdateRequest, validationApplicationUpdate} from './ApplicationModel'

type Props = {
  application: IApplicationModel | null
  loading: boolean
  onClose: () => void
  onSubmit: (request: IApplicationUpdateRequest) => void
}

const emptyForm: IApplicationUpdateRequest = {
  firstname: '',
  lastname: '',
  email: '',
  phone: '',
  candidateLocation: '',
}

/** Başvurudaki kişisel bilgilerin düzeltilmesi; ilan ve cevaplar değiştirilemez */
export const ApplicationEditModal: FC<Props> = ({application, loading, onClose, onSubmit}) => {
  const formik = useFormik<IApplicationUpdateRequest>({
    initialValues: emptyForm,
    validationSchema: validationApplicationUpdate,
    onSubmit: (values) =>
      onSubmit({
        firstname: values.firstname.trim(),
        lastname: values.lastname.trim(),
        email: values.email.trim(),
        phone: values.phone.trim(),
        candidateLocation: values.candidateLocation.trim(),
      }),
  })

  useEffect(() => {
    if (!application) return
    formik.resetForm({
      values: {
        firstname: application.firstname,
        lastname: application.lastname,
        email: application.email,
        phone: application.phone ?? '',
        candidateLocation: application.candidateLocation ?? '',
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [application])

  const fieldError = (field: keyof IApplicationUpdateRequest) =>
    formik.touched[field] && formik.errors[field] ? formik.errors[field] : undefined

  const renderInput = (field: keyof IApplicationUpdateRequest, label: string, required = false) => (
    <div className='col-md-6'>
      <label className={`form-label fw-bold ${required ? 'required' : ''}`}>{label}</label>
      <input
        type='text'
        className={`form-control ${fieldError(field) ? 'is-invalid' : ''}`}
        {...formik.getFieldProps(field)}
      />
      {fieldError(field) && <div className='invalid-feedback'>{fieldError(field)}</div>}
    </div>
  )

  return (
    <Modal show={!!application} onHide={onClose} size='lg' dialogClassName='modal-dialog-centered' backdrop='static'>
      <form onSubmit={formik.handleSubmit} noValidate>
        <div className='modal-header'>
          <h5 className='modal-title'>Başvuruyu Düzenle</h5>
          <button type='button' className='btn-close' onClick={onClose} />
        </div>
        <div className='modal-body'>
          <div className='text-muted mb-6'>{application?.jobTitle}</div>
          <div className='row g-5'>
            {renderInput('firstname', 'Ad', true)}
            {renderInput('lastname', 'Soyad', true)}
            {renderInput('email', 'E-posta', true)}
            {renderInput('phone', 'Telefon')}
            {renderInput('candidateLocation', 'Yaşadığı Yer')}
          </div>
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-light' onClick={onClose}>
            İptal
          </button>
          <button type='submit' className='btn btn-primary' disabled={loading}>
            {loading ? <span className='spinner-border spinner-border-sm' /> : 'Güncelle'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
